/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { IoAddCircleSharp } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import scus from "state-counties-us";
import AddressField from "../CaseView/link case/AddressField";
import BasicInformationFormSection from "../CaseView/link case/BasicInformationFormSection";
export default function AddNewCaseForm() {
  const [loading, setLoading] = useState(false);
  const [suggestedAddresses, setSuggestedAddresses] = useState({});
  const [verifyingIndexes, setVerifyingIndexes] = useState([]);
  const [countyOptionsMap, setCountyOptionsMap] = useState({});
  const skipVerificationRef = useRef(new Set());
  const prevVerifiableFields = useRef({});
  const { id, personID } = useParams();
  const { register, control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      ADDRESS: [
        {
          TYPE: "HOME",
          PRIMARY: true,
          STREET_1: "",
          STREET_2: "",
          CITY: "",
          STATE: "",
          COUNTY: "",
          ZIP: "",
          COUNTRY: "US",
          TELEPHONE_HOME: "",
          TELEPHONE_MOBILE: "",
          TELEPHONE_WORK: "",
        },
      ],
      RACE: [],
      TRIBE: [],
    },
  });
  const addresses = useWatch({ name: "ADDRESS", control });
  const {
    fields: addressFields,
    prepend: prependAddress,
    remove: removeAddress,
  } = useFieldArray({ control, name: "ADDRESS" });
  const onSubmit = (data) => {
    setLoading(true);
    const addresses = data.ADDRESS.map((addr) => {
      const { TELEPHONE_WORK, TELEPHONE_WORK_EXT, ...rest } = addr;
      const newAddress = {
        ...rest,
        ...(TELEPHONE_WORK && {
          TELEPHONE_WORK: TELEPHONE_WORK_EXT
            ? `${TELEPHONE_WORK} x ${TELEPHONE_WORK_EXT}`
            : TELEPHONE_WORK,
        }),
      };
      return newAddress;
    });
    const result = {
      LINK_TYPE: data?.LINK_TYPE,
      SOURCE_CASE: { id: id, PERSON_ID: personID },
      MODE: "NEW_PERSON_NEW_CASE",
      PERSON: {
        ...data,
        ADDRESS: addresses,
        TYPE: "PERSON",
      },
    };

    fetch("/api/createLink", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(result),
    })
      .then((data) => {
        if (data?.status === 200) {
          toast.success("Successs");
          console.log("Response:", data);
          setLoading(false);
          window.location.reload();
        } else {
          toast.error("something went wrong");
          console.error("Error:", data);
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error("something went wrong");
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const verifyAddress = async (index) => {
    setVerifyingIndexes((prev) => [...prev, index]);

    const values = addresses[index];
    const { STREET_1, CITY, STATE, ZIP, STREET_2 } = values;

    const query = `STREET1=${
      STREET_1?.trim().replace(/\s+/g, "+") || ""
    }&STREET2=${STREET_2?.trim().replace(/\s+/g, "+") || ""}}&CITY=${
      CITY?.trim().replace(/\s+/g, "+") || ""
    }&STATE=${STATE || ""}&ZIP=${ZIP || ""}`;
    const url = `/api/getAddress?${query}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "text/plain; charset=utf-8",
        },
      });

      if (!response.ok) throw new Error("Failed to verify address");
      const text = await response.text();
      const data = JSON.parse(text);
      setSuggestedAddresses((prev) => ({
        ...prev,
        [index]: data,
      }));
    } catch (err) {
      console.error(err);
      toast.error("Verification Failed");
    } finally {
      setVerifyingIndexes((prev) => prev.filter((i) => i !== index));
    }
  };

  useEffect(() => {
    const timeouts = [];

    addresses?.forEach((addr, index) => {
      const { STREET_1, STREET_2, CITY, STATE, ZIP } = addr || {};
      const isVerifiable = STREET_1 && STATE && (CITY || ZIP);

      const prev = prevVerifiableFields.current[index] || {};
      const hasChanged =
        prev.STREET_1 !== STREET_1 ||
        prev.CITY !== CITY ||
        prev.STATE !== STATE ||
        prev.ZIP !== ZIP;

      if (
        !isVerifiable ||
        !hasChanged ||
        skipVerificationRef.current.has(index)
      ) {
        skipVerificationRef.current.delete(index);
        return;
      }

      // Store current values for future comparison
      prevVerifiableFields.current[index] = {
        STREET_1,
        STREET_2,
        CITY,
        STATE,
        ZIP,
      };

      const timeout = setTimeout(() => {
        verifyAddress(index);
      }, 1000);
      timeouts.push(timeout);
    });

    return () => timeouts.forEach(clearTimeout);
  }, [addresses]);

  const handleUseSuggested = (index) => {
    const suggestion = suggestedAddresses[index];
    if (!suggestion) return;
    // Skip triggering verification again
    skipVerificationRef.current.add(index);
    setValue(`ADDRESS.${index}.STREET_1`, suggestion.STREET1 || "");
    setValue(`ADDRESS.${index}.STREET_2`, suggestion.STREET2 || "");
    setValue(`ADDRESS.${index}.CITY`, suggestion.CITY || "");
    setValue(`ADDRESS.${index}.STATE`, suggestion.STATE || "");
    setValue(`ADDRESS.${index}.ZIP`, suggestion.ZIP || "");
    setSuggestedAddresses((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };

  useEffect(() => {
    addresses?.forEach((addr, index) => {
      const stateCode = addr?.STATE;
      if (stateCode && !countyOptionsMap[stateCode]) {
        const counties = scus.getCountiesByState(stateCode) || [];
        setCountyOptionsMap((prev) => ({
          ...prev,
          [stateCode]: counties.map((c) => ({
            value: `${c} County`,
            label: `${c} County`,
          })),
        }));
      }
    });
  }, [addresses]);
  return (
    <Box minH="80vh">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex gap={2}>
          {/* Basic Info */}
          <BasicInformationFormSection
            watch={watch}
            setValue={setValue}
            register={register}
          />

          {/* Address Info */}
          <Box w="70%">
            <Text
              fontSize="sm"
              fontWeight="bold"
              mb={1}
              display="flex"
              alignItems="center"
              gap={2}
            >
              Address Information{" "}
              <IoAddCircleSharp
                cursor="pointer"
                fontSize={20}
                onClick={() =>
                  prependAddress({
                    TYPE: "HOME",
                    PRIMARY: true,
                    STREET_1: "",
                    STREET_2: "",
                    CITY: "",
                    STATE: "",
                    COUNTY: "",
                    ZIP: "",
                    COUNTRY: "US",
                    TELEPHONE_HOME: "",
                    TELEPHONE_MOBILE: "",
                    TELEPHONE_WORK: "",
                  })
                }
              />
            </Text>
            <SimpleGrid columns={2} spacing={4}>
              {addressFields.map((field, index) => (
                <AddressField
                  key={field.id}
                  index={index}
                  field={field}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  remove={removeAddress}
                  verifying={verifyingIndexes.includes(index)}
                  suggested={suggestedAddresses[index]}
                  onUseSuggested={handleUseSuggested}
                  addresses={addresses}
                  countyOptionsMap={countyOptionsMap}
                />
              ))}
            </SimpleGrid>
          </Box>

          {/* Submit */}
          <Box textAlign="right" position="absolute" bottom={2} right={4}>
            <Button variant="primary" type="submit" mt={4} disabled={loading}>
              Submit
            </Button>
          </Box>
        </Flex>
      </form>
    </Box>
  );
}
